var AnalyticsEventName;
(function (AnalyticsEventName) {
    AnalyticsEventName["SelectParentRnaAnalysisCheckbox"] = "Select parent RNA analysis with checkbox";
    AnalyticsEventName["DeselectParentRnaAnalysisCheckbox"] = "Deselect parent RNA analysis with checkbox";
    AnalyticsEventName["DeselectParentRnaAnalysisModal"] = "Deselect parent RNA analysis with warning modal";
    AnalyticsEventName["SelectReflexRnaAnalysisCheckbox"] = "Select reflex RNA analysis with checkbox";
    AnalyticsEventName["DeselectReflexRnaAnalysisCheckbox"] = "Deselect reflex RNA analysis with checkbox";
    AnalyticsEventName["DeselectReflexRnaAnalysisModal"] = "Deselect reflex RNA analysis with warning modal";
    AnalyticsEventName["AddToCartErrors"] = "Errors when adding to cart";
    AnalyticsEventName["SavedCustomOrder"] = "Saved custom order";
    AnalyticsEventName["CanceledSavingCustomOrder"] = "Canceled saving custom order";
})(AnalyticsEventName || (AnalyticsEventName = {}));

export { AnalyticsEventName };
//# sourceMappingURL=analytics.esm.js.map
